import clsx, { ClassValue } from 'clsx'
import { DetailedHTMLProps, ReactNode } from 'react'

export type TextareaProps =
  Omit<DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, 'size'> & {
    label?: ReactNode
    size?: 'lg' | 'md' | 'sm' | 'xs'
    className?: ClassValue
    helperText?: ReactNode
    error?: boolean
  }

export function Textarea (props: TextareaProps) {
  const { label, size, className, helperText, error, ...textareaProps } = props

  return (
    <label className="fieldset w-full">
      {label !== undefined && (
        <div className="label">
          <span
            className={clsx(
              'label-text',
              error && 'text-error'
            )}
          >
            {label}
          </span>
        </div>
      )}
      <textarea
        className={clsx(
          'textarea',
          'textarea-bordered',
          error && 'textarea-error',
          {
            'textarea-lg': size === 'lg',
            'textarea-md': size === 'md',
            'textarea-sm': size === 'sm',
            'textarea-xs': size === 'xs'
          },
          'leading-normal',
          className
        )}
        {...textareaProps}
      />
      {helperText !== undefined && (
        <div className="label py-1">
          <span
            className={clsx(
              'label-text-alt',
              'min-h-4',
              error && 'text-error'
            )}
          >
            {helperText}
          </span>
        </div>
      )}
    </label>
  )
}
